module.exports = __webpack_public_path__ + "static/media/3DPPA5.5731f05f.jpg";